module.exports = __webpack_public_path__ + "img/1440.4a5d293f.jpg";